import './styles/MenuStart.css';
import React, { Component } from "react";

class MenuStart extends Component {
    render(){
      return (
        <div id="cont" className="text-center">
          <div style={{height: 10+"rem"}}></div>
          <h1 className="mt-4 mb-3 text-white titol align-self-center display-1">Xinergy</h1>
          <h5 className="text-secondary">Proximament...</h5>
          <a id="descarrega" href="/descarregues">Descarrega les versions de Java/Android Studio</a>
        </div>
      );
    }
}

export default MenuStart;